import api from 'api'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    reversePayment: build.mutation({
      query: ({ paymentNumber, force }) => ({ url: `/api/v1/billing/payment/${paymentNumber}/reverse`, method: 'POST', body: { force } }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
    refundPayment: build.mutation({
      query: ({ paymentNumber, force, failed, refundCreditTransaction }) => ({
        url: `/api/v1/billing/payment/${paymentNumber}/reverse`,
        method: 'POST',
        body: { force, failed, refundCreditTransaction },
      }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
    partialRefundPayment: build.mutation({
      query: ({ paymentNumber, amountCents, note }) => ({
        url: `/api/v1/billing/payment/${paymentNumber}/reverse-partial`,
        method: 'POST',
        body: { amountCents, note },
      }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
    voidPayment: build.mutation({
      query: ({ paymentNumber }) => ({
        url: `/api/v1/billing/payment/${paymentNumber}/void`,
        method: 'POST',
      }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { useReversePaymentMutation, useRefundPaymentMutation, usePartialRefundPaymentMutation, useVoidPaymentMutation } = extendedApi
